export default __webpack_public_path__ + "static/media/warningIcon.0fd784ef.svg";